export default __webpack_public_path__ + "static/img-art-pandas-profiling-6-8fed5a1c3b46e30acd7abe548390b586.png";